import React from 'react';
import { useAuth } from 'react-oidc-context';

import styles from './ModalAccountRequired.module.scss';
import { CloseIcon } from '@src/Components/Icons';
import { MythicIcon } from '@src/Pages/WorldMap/MapIcon/MapIcon';
import ButtonDefault from '@src/Components/Atoms/ButtonDefault/ButtonDefault';

type IModalAccountRequired = {
  onClose?: () => void;
};

const ModalAccountRequired: React.FC<IModalAccountRequired> = ({ onClose }) => {
  const { signinRedirect } = useAuth();
  return (
    <div className={styles['container']} data-testid="modal-account-required">
      <div className={styles['drop-shadow']} onClick={onClose} />
      <div className={styles['content-wrapper']}>
        <div className={styles['header-content']}>
          <p>Mythic Account Required</p>
          <div className={styles['modal-close-icon']} onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className={styles['content-field']}>
          <div className={styles['logo-wrapper']}>
            <MythicIcon />
          </div>
          <p className={styles['description']}>Mythic Account Required</p>
          <div className={styles['button-wrapper']}>
            <div className={styles['left-button']}>
              <ButtonDefault
                variant="red"
                label="Create Account"
                onClick={() => signinRedirect()}
              />
            </div>
            <div className={styles['right-button']}>
              <ButtonDefault label="Login" onClick={() => signinRedirect()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAccountRequired;
